<app-master-list-item
  [route]="route"
  [entityData]="trackedTimeData"
  [actions]="trackedTimeActions"
  [featureName]="featureName"
  [listFilter]="listFilter"
  [notifyOfDeleteOptions]="notifyOfDeleteOptions"
  [trackingScreenName]="trackingScreenName"
  type="tracked-time-list-item"
  dropdownE2eId="tracked-time-list-item-dropdown-trigger"
  (onAction)="onAction.emit($event)"
>
</app-master-list-item>
